(function () {
  'use strict';
  if (window.TMOT_DUPLICATE_FORM_GUARD) return;
  window.TMOT_DUPLICATE_FORM_GUARD = true;
  var handled = new WeakSet();
  function dismissDuplicate() {
    var form = document.querySelector('form[data-testid="klaviyo-form-TnfZqy"]');
    if (!form) return;
    var dialog = form.closest('[role="dialog"][aria-label="POPUP Form"]');
    var close = dialog && dialog.querySelector('button[aria-label="Close dialog"]');
    if (close && !handled.has(close)) {
      handled.add(close);
      setTimeout(function () {
        if (close.isConnected) close.click();
      }, 50);
    }
  }
  var observer = new MutationObserver(function (records) {
    if (records.some(function (record) { return record.addedNodes.length > 0; })) dismissDuplicate();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  window.addEventListener('klaviyoForms', function (event) {
    if (event.detail && event.detail.formId === 'TnfZqy') dismissDuplicate();
  });
  dismissDuplicate();
})();
